module.exports = __webpack_public_path__ + "img/colorpicker_overlay.47ca4ed4.png";